<template lang="pug">
aside.dashboard-side-bar(v-horizontal-scroll)
  .menu(v-if="isVendor")
    .item(v-if="vendorShowAllTabs && checkVendorPermission('vendors-analytics')")
      nuxt-link(:to="{name: 'vendors-analytics'}" v-click="() => $amplitude.track('CLICK_VENDOR_DASHBOARD_ANALYTICS_TAB')")
        i.icon.bx.bx-pie-chart-alt-2
        span.label Insights

    .item(v-if="(vendorShowAllTabs || hasOrders) && checkVendorPermission('vendors-orders')")
      nuxt-link(:to="{name: 'vendors-orders'}")
        i.icon.bx.bx-cart-alt
        span.label Orders

    .item(v-if="(vendorShowAllTabs|| hasSamples) && checkVendorPermission('vendors-samples')")
      nuxt-link(:to="{name: 'vendors-samples'}")
        i.icon.bx.bxs-eyedropper
        span.label Samples

    .item(v-if="vendorShowAllTabs && checkVendorPermission('vendors-products')" ref="vendorProducts")
      el-popover(
        :ref="POPUP_REFS.VENDOR_PRODUCT"
        :placement="placement"
        trigger="manual"
        width="350"
        popper-class="el-popover--success onboarding-popover")
        .content Click here to create your first product and SKU.
        .tr
          el-button(type="text" @click="hideVendorOnboardingPopup(POPUP_REFS.VENDOR_PRODUCT)") Close
        nuxt-link(slot="reference" :to="{name: 'vendors-products'}")
          i.icon.bx.bx-copy
          span.label Products

    .item(v-if="vendorShowAllTabs && hasInventoryInformation && checkVendorPermission('vendors-inventory')")
      nuxt-link(:to="{name: 'vendors-inventory'}")
        component(value="!" type="primary" :is="numberOfPodPlanned ? 'el-badge' : 'div'")
          i.icon.bx.bx-package
          span.label Inventory

    .item(v-if="(vendorShowAllTabs || showBrandTab) && checkVendorPermission('vendors-brands')" ref="vendorBrands")
      el-popover(
        :ref="POPUP_REFS.VENDOR_BRAND"
        :placement="placement"
        trigger="manual"
        width="350"
        popper-class="el-popover--success onboarding-popover")
        .content Click here to create your first brand.
        .tr
          el-button(type="text" @click="hideVendorOnboardingPopup(POPUP_REFS.VENDOR_BRAND)") Close
        nuxt-link(slot="reference" :to="{name: 'vendors-brands'}")
          i.icon.bx.bx-copyright
          span.label Brands

    .item(v-if="!isBroker && vendorShowAllTabs && checkVendorPermission('vendors-stores')")
      nuxt-link(:to="{name: 'vendors-stores'}" v-click="() => $amplitude.track('CLICK_VENDOR_DASHBOARD_STORE_LIST_TAB')")
        i.icon.bx.bx-store-alt
        span.label Store List

    .item(v-if="vendorShowAllTabs && checkVendorPermission('vendors-payments')")
      nuxt-link(:to="{name: 'vendors-payments'}" v-click="() => $amplitude.track('CLICK_VENDOR_DASHBOARD_PAYMENT_TAB')")
        //- img.custom-icon(v-if="isMobile && isFinanceTab" src="/img/icon.finance-white.svg")
        //- img.custom-icon(v-else src="/img/icon.finance-primary.svg")
        i.icon.bx.bx-calculator
        span.label Finance

    .item(v-if="vendorShowAllTabs && checkVendorPermission('vendors-promotions')")
      nuxt-link(:to="{name: 'vendors-promotions'}")
        i.icon.bx.bx-purchase-tag-alt
        span.label Promotions

    .item(v-if="!isBroker && vendorShowAllTabs && checkVendorPermission('vendors-widgets')" ref="vendorWidgets")
      nuxt-link(
        :to="{name: 'vendors-widgets'}"
        slot="reference"
        v-click="() => $amplitude.track('CLICK_VENDOR_DASHBOARD_WIDGETS_TAB')")
        i.icon.bx.bxs-widget
        span.label Widgets

    .item(v-if="vendorShowAllTabs && checkVendorPermission('vendors-claims')")
      nuxt-link(:to="{name: 'vendors-claims'}")
        i.icon.bx.bx-support
        span.label Claims

    .item(v-if="!isBroker && vendorShowAllTabs && checkVendorPermission('vendors-notifications')")
      nuxt-link.noti-badge(:to="{name: 'vendors-notifications'}" v-click="() => $amplitude.track('CLICK_VENDOR_DASHBOARD_NOTIFICATIONS_TAB')")
        component(:is="unreadNotifications? 'el-badge': 'div'" :max="99" :value="unreadNotifications" type="primary" )
          i.icon.bx.bx-bell
          span.label Notifications

    .item(ref="vendorSettings")
      el-popover(
        :ref="POPUP_REFS.VENDOR_SETTING_PAYMENT"
        :placement="placement"
        trigger="manual"
        width="350"
        popper-class="el-popover--success onboarding-popover")
        .content Click here and visit the <strong>Payments</strong> page to complete <strong>Bank account</strong> and <strong>Payments</strong> information.
        .tr
          el-button(type="text" @click="hideVendorOnboardingPopup(POPUP_REFS.VENDOR_SETTING_PAYMENT)") Close
        nuxt-link(slot="reference" :to="{name: 'vendors-settings'}")
          i.icon.bx.bx-cog
          span.label Settings

  .menu(v-if="isBuyer")
    .item
      nuxt-link(:to="{name: 'buyers-analytics'}" v-click="() => $amplitude.track('CLICK_BUYER_DASHBOARD_ANALYTICS_TAB')")
        i.icon.bx.bx-pie-chart-alt-2
        span.label Analytics
    .item
      nuxt-link(:to="{name: 'buyers-orders'}" v-click="() => $amplitude.track('CLICK_BUYER_DASHBOARD_ORDERS_TAB')")
        i.icon.bx.bx-cart-alt
        span.label Orders
    .item
      nuxt-link(:to="{name: 'buyers-samples'}")
        i.icon.bx.bxs-eyedropper
        span.label Samples
    .item
      nuxt-link(:to="{name: 'buyers-payments'}" v-click="() => $amplitude.track('CLICK_BUYER_DASHBOARD_PAYMENT_TAB')")
        i.icon.bx.bx-clipboard
        span.label Payments
    .item
      nuxt-link(:to="{name: 'buyers-settings'}")
        i.icon.bx.bx-cog
        span.label Settings

  .menu(v-if="isHeadBuyer")
    .item
      nuxt-link(:to="{name: 'head-buyer-analytics'}" v-click="() => $amplitude.track('CLICK_BUYER_DASHBOARD_ANALYTICS_TAB')")
        i.icon.bx.bx-pie-chart-alt-2
        span.label Analytics
    .item
      nuxt-link(:to="{name: 'head-buyer-orders'}" v-click="() => $amplitude.track('CLICK_BUYER_DASHBOARD_ORDERS_TAB')")
        i.icon.bx.bx-cart-alt
        span.label Orders
    .item
      nuxt-link(:to="{name: 'head-buyer-samples'}")
        i.icon.bx.bxs-eyedropper
        span.label Samples
    .item
      nuxt-link(:to="{name: 'head-buyer-payments'}" v-click="() => $amplitude.track('CLICK_BUYER_DASHBOARD_PAYMENT_TAB')")
        i.icon.bx.bx-clipboard
        span.label Payments
    .item
      nuxt-link(:to="{name: 'head-buyer-settings'}")
        i.icon.bx.bx-cog
        span.label Settings

  .menu(v-if="isLP")
    .item
      nuxt-link(:to="{name: 'lp-orders'}")
        i.icon.bx.bx-cart-alt
        span.label Orders
    .item(v-if="isWarehouseLP")
      nuxt-link(:to="{name: 'lp-inventory'}")
        i.icon.bx.bx-package
        span.label Inventory
    .item(v-if="isPodFreightLP")
      nuxt-link(:to="{name: 'lp-pod-freight'}")
        i.icon.bx.bxs-cube
        span.label Pod Freight
    .item
      nuxt-link(:to="{name: 'lp-settings'}")
        i.icon.bx.bx-cog
        span.label Settings
</template>

<script>
import { mapGetters } from 'vuex'
import { STORE_LIST_URL, DEBOUNCE_DELAY, POPUP_REFS } from '~/settings'
import { debounce } from 'lodash'

export default {
  data () {
    return {
      POPUP_REFS,
      STORE_LIST_URL,
      debouncedResize: debounce(this.resize, DEBOUNCE_DELAY)
    }
  },

  async fetch () {
    try {
      await this.$nextTick()
      this.showVendorOnboardingPopup()
    } catch (e) {}
  },

  computed: {
    ...mapGetters({
      user: 'authentication/user',
      isBroker: 'authentication/isBroker',
      isVendor: 'authentication/isVendor',
      isBuyer: 'authentication/isBuyer',
      isHeadBuyer: 'authentication/isHeadBuyer',
      isLP: 'authentication/isLP',
      isWarehouseLP: 'authentication/isWarehouseLP',
      numberOfPodPlanned: 'master/numberOfPodPlanned',
      isPodFreightLP: 'authentication/isPodFreightLP',
      unreadNotifications: 'notifications/unreadNotifications',
      vendorCompanySelected: 'broker/vendorCompanySelected',
      isVendorAdmin: 'authentication/isVendorAdmin',
      vendorPermissionRoutes: 'authentication/vendorPermissionRoutes',
      stripeConnectType: 'authentication/stripeConnectType',
      addedBothBankAndCard: 'authentication/addedBothBankAndCard',
      showAllTabs: 'authentication/showAllTabs',
      hasBrand: 'authentication/hasBrand',
      vendorHasBrandWithoutPlan: 'authentication/vendorHasBrandWithoutPlan',
      vendorSuspended: 'authentication/vendorSuspended',
      hasOrders: 'authentication/hasOrders',
      hasSamples: 'authentication/hasSamples'
    }),

    isMobile () {
      if (!process.client) return false
      return window?.innerWidth < 768
    },

    isFinanceTab () {
      return this.$route.name?.includes('vendors-payments')
    },

    showBrandTab () {
      return this.addedBothBankAndCard && !this.hasBrand
    },

    vendorShowAllTabs () {
      const hasPayoutPaymentBrand =
        this.addedBothBankAndCard &&
        this.hasBrand &&
        !this.vendorHasBrandWithoutPlan

      return !this.vendorSuspended && (this.showAllTabs || hasPayoutPaymentBrand)
    },

    hasInventoryInformation () {
      return this.vendorCompanySelected?.has_inventory_information ||
         this.user?.has_inventory_information
    },

    placement () {
      return window.innerWidth > 768 ? 'right' : 'bottom'
    }
  },

  mounted () {
    this.$bus.$on('re-render-vendor-onboarding-popups', (data) => {
      this.showVendorOnboardingPopup(data?.disableScroll)
    })

    window.addEventListener('resize', this.debouncedResize)
    this.resize()
  },

  destroyed () {
    this.$bus.$off('re-render-vendor-onboarding-popups', this.showVendorOnboardingPopup)
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.debouncedResize)
  },

  methods: {
    checkVendorPermission (route) {
      if (this.isVendorAdmin || this.isBroker) return true

      return this.vendorPermissionRoutes.some(e => route.includes(e))
    },

    resize () {
      // Fix el-popover is wrong position when announcement bar is on
      window.dispatchEvent(new Event('resize'))
    },

    showVendorOnboardingPopup (disableScroll = false) {
      if (!this.isVendor || this.isBroker || this.vendorShowAllTabs) return

      // Close first
      this.$refs[POPUP_REFS.VENDOR_SETTING_PAYMENT]?.doClose()
      this.$refs[POPUP_REFS.VENDOR_BRAND]?.doClose()
      this.$refs[POPUP_REFS.VENDOR_PRODUCT]?.doClose()
      this.$refs[POPUP_REFS.VENDOR_WHOLESALE_WIDGET]?.doClose()

      // Payment Popup
      const showPaymentPopup =
        this.$route.name !== 'vendors-settings' &&
        this.$route.name !== 'vendors-settings-payments' &&
        !this.addedBothBankAndCard &&
        !this.$preferences.get(`$hide_${POPUP_REFS.VENDOR_SETTING_PAYMENT}`)

      if (showPaymentPopup) {
        this.$refs[POPUP_REFS.VENDOR_SETTING_PAYMENT]?.doShow()
        !disableScroll && this.$refs.vendorSettings?.scrollIntoView()
        return
      }

      // Brand Popup
      const showBrandPopup =
        !this.user?.has_brand &&
        this.$route.name !== 'vendors-brands' &&
        this.$route.name !== 'vendors-brands-id' &&
        !this.$preferences.get(`$hide_${POPUP_REFS.VENDOR_BRAND}`) &&
        this.addedBothBankAndCard

      if (showBrandPopup) {
        this.$refs[POPUP_REFS.VENDOR_BRAND]?.doShow()
        !disableScroll && this.$refs.vendorBrands?.scrollIntoView()
        return
      }

      // Product Popup
      const showProductPopup =
        !this.user?.has_product &&
        this.user?.has_valid_brand &&
        this.$route.name !== 'vendors-products' &&
        !this.$preferences.get(`$hide_${POPUP_REFS.VENDOR_PRODUCT}`) &&
        this.addedBothBankAndCard
      if (showProductPopup) {
        this.$refs[POPUP_REFS.VENDOR_PRODUCT]?.doShow()
        !disableScroll && this.$refs.vendorProducts?.scrollIntoView()
      }
    },

    hideVendorOnboardingPopup (refName) {
      this.$refs[refName]?.doClose()
      this.$preferences.set(`$hide_${refName}`, true)
    }
  }
}
</script>
<style lang="scss">
.onboarding-popover {
  z-index: 2000 !important;
}
</style>
<style lang="scss" scoped>
aside.dashboard-side-bar {
  // background: linear-gradient(180deg, darken($--color-page-background, 4), transparent);
  margin-right: 0;
  background: white;
  overflow-x: auto;
  @include modern-scroller();
  @include media(xs-only) {
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    border-bottom: $--border-light;
  }
  @include media(sm) {
    background: darken($--color-page-background, 5);
    min-height: calc(100vh - 95px);
    border-right: $--border-light;
  }
  @include media(md) {
    overflow-x: hidden;
  }
  .menu {
    position: relative;
    display: flex;
    min-width: min-content;
    overflow: hidden;
    @include media(sm) {
      display: block;
    }
    .item {
      position: relative;
      min-width: 88px;
      &:first-child {
        a.nuxt-link-active {
          border-top-color: transparent;
        }
      }
      a {
        align-items: center;
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        border: 1px solid transparent;
        padding: 6px 12px;
        height: 100%;
        @include media(sm) {
          margin-right: -1px;
          padding: 12px 10px;
        }
        &.nuxt-link-active {
          background: $--color-page-background;
          border-top-color: $--color-border-light;
          border-bottom-color: $--color-border-light;
          .icon {
            color: $--color-primary;
          }
          .label {
            color: $--color-text-regular;
          }
          @include media(xs-only) {
            background: $--color-primary;
            border-top-color: transparent;
            border-bottom-color: transparent;
            .icon {
              color: white;
            }
            .label {
              color: white;
            }
          }
        }
        .icon {
          color: $--color-primary;
          font-size: 1.75rem;
        }
        .custom-icon {
          width: 25px;
          height: 25px;
          margin-left: 4px;
        }
        .label {
          display: block;
          font-size: 12px;
          line-height: 1.25em;
          margin-top: .2em;
          flex: 1;
          @include media(sm) {
            font-weight: $--font-weight-bold;
          }
        }
      }

      .el-badge__content{
        top: 10px;
        right: 20px;
      }
    }
  }
}
.noti-badge {
  ::v-deep {
    .el-badge__content.is-fixed {
      transform: translateY(-50%) translateX(50%);
    }
  }
}
</style>
